import Image from 'next/image'
import styled from 'styled-components'
import device from '../../styles/device'
import { Panel, Grid, Item } from '../../styles/global.elements'

const DocumentItem = styled(Item)`
  width: 100%;
  
  @media ${device.xl} {
    margin: 0 2rem;
    ${props => props.reverse && `order: ${props.reverse ? -1 : 1};`}
  }
`

const DocumentDetail = ({ documentName, detail, img, reverse }) => {
  return (    
    <Panel mb="2rem">
      <Grid breakpoint="xl" align="stretch" p="1rem 0">
        <DocumentItem>
          <Image
            src={img}
            layout="responsive"
            width={1000}
            height={600}
            alt={documentName}
          />
          <p>
            <b>{documentName}</b>
          </p>
        </DocumentItem>
        <DocumentItem size={2} reverse={reverse}>
          {detail}
        </DocumentItem>
        <br />
      </Grid>
    </Panel>
  )
}
 
export default DocumentDetail;